import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Eye, EyeClosed } from "@air/next-icons";
import { dropdownMenuItem } from "@air/primitive-dropdown-menu";
import { memo } from "react";
import { VISIBILITY_TOGGLE } from "~/constants/testIDs";
export const ViewVisibilityToggle = /*#__PURE__*/ memo((param)=>{
    let { option, prefix, ...rest } = param;
    return /*#__PURE__*/ _jsxs("button", {
        className: dropdownMenuItem({
            size: "small"
        }),
        "data-testid": "".concat(VISIBILITY_TOGGLE, "-").concat(option.fieldName),
        ...rest,
        children: [
            !!prefix ? /*#__PURE__*/ _jsx("div", {
                className: "mr-2 shrink-0",
                children: prefix
            }) : null,
            /*#__PURE__*/ _jsx("div", {
                className: "flex min-w-0 grow truncate text-14",
                children: option.label
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "ml-2 shrink-0 text-grey-10",
                children: option.isVisible ? /*#__PURE__*/ _jsx(Eye, {
                    "data-testid": "".concat(option.fieldName, "-visible"),
                    width: 16
                }) : /*#__PURE__*/ _jsx(EyeClosed, {
                    "data-testid": "".concat(option.fieldName, "-not-visible"),
                    width: 16
                })
            })
        ]
    });
});
ViewVisibilityToggle.displayName = "ViewVisibilityToggle";
